(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-choice-button.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-choice-button.js');
"use strict";

const {
  RadioButton
} = svs.ui.reactForm;
const {
  HighscoreContext
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  useContext
} = React;
const HighscoreChoiceButton = _ref => {
  let {
    type: choiceType,
    children,
    disabled = false
  } = _ref;
  const {
    type,
    changeType
  } = useContext(HighscoreContext);
  return React.createElement(RadioButton, {
    checked: choiceType === type,
    disabled: disabled,
    onChange: () => {
      changeType(choiceType);
    },
    value: choiceType
  }, children);
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreChoiceButton', HighscoreChoiceButton);

 })(window);